import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="m-auto marginBody flex flex-col gap-10 md:gap-20 py-10">
      <div className="flex flex-col items-center justify-center gap-5">
        <h3 className="heading1 !text-primary !font-medium">TERMS OF USE</h3>
        <p className="paragraph2">Learn more about us</p>
      </div>
      <p className="paragraph1">
        We take your privacy seriously. By clicking the button, you agree to be
        matched with partners from our network, and consent (not required as a
        condition to purchase a good/service) for us and/or them to contact you
        (including through automated means; e.g. autodialing, text and
        pre-recorded messaging) via telephone, mobile device (including SMS and
        MMS), and/or email, even if you are on a corporate, state or national Do
        Not Call Registry.GFN Capital operates this website to provide online
        access to information about GFN Capital and its products, services and
        opportunities. By accessing and using this site, you agree to each of
        the terms and conditions set forth herein (“Terms of Use”). Additional
        terms and conditions applicable to the specific areas of this site are
        posted throughout the site and, together with these Terms of Use, govern
        your use of these areas, content and/or transactions. GFN Capital
        reserves the right to modify the content of its website, including the
        Terms of Use, without prior notice. Your use of the site constitutes
        your agreement to follow and be bound by the terms and conditions of the
        site, as well as these Terms of Use, as modified. You are encouraged to
        review the website and these Terms of Use periodically for updated and
        modifications. Authorized Use You are granted a limited license to
        access and use the website, and to download or print a copy of any
        portion of the content solely for your personal or informational use,
        provided that you keep all copyright or other proprietary notices
        intact. You may not copy, display, modify, publish, reproduce, store,
        transmit, post, create other derivative works from, or sell, rent or
        license any part of the content obtained from the website in any medium
        to anyone, except as otherwise expressly permitted under these Terms of
        Use, relevant license or authorization by GFN Capital. Said limited
        license is subject to these Terms of Use, and does not include use of
        any data mining, robots, or similar data gathering or extraction
        methods. You further agree that you will NOT do any of the following:
        Harvest or collect email addresses or other contact information of
        portal users from the website by electronic or other means for the
        purposes of sending unsolicited emails or other unsolicited
        communications. Use automated scripts to collect information from the
        website or for any other purpose Register for more than one portal user
        account, register for a portal user account on behalf of an individual
        other than yourself, or register for a portal user account on behalf of
        any group or entity. Impersonate any person or entity or falsely state
        or otherwise misrepresent yourself, your age, or your affiliation with
        any person or entity. Upload, post, transmit, share, or otherwise make
        available any unsolicited or unauthorized advertising, solicitations,
        promotional materials, “junk mail,” “spam,” “chain letters,” “pyramid
        schemes,” or any other form of solicitation. Upload, post, transmit,
        share, store, or otherwise make publicly available on the website any
        private information of any third party, including, without limitation,
        addresses, phone numbers, email addresses, social security numbers, and
        credit card numbers. Upload, post, transmit, share, or otherwise make
        available any material that contains software viruses or any other
        computer code, files, or programs designed to interrupt, destroy, or
        limit the functionality of any computer software or hardware or
        telecommunications equipment. Use or attempt to use another’s account,
        service, or system without authorization from GFN Capital, or create a
        false identity on the website. Upload, post, transmit, share, store, or
        otherwise make available content that, in the sole judgment of GFN
        Capital, is objectionable or which restricts or inhibits any other
        person from using or enjoying the website, or which may expose GFN
        Capital or its affiliates, licensors and their respective officers,
        directors, employees, agents and representatives, or website users to
        any harm or liability of any type. GFN Capital reserves the right, in
        its sole discretion, to restrict, in whole or in part, your use of the
        Site, any Site Content, any Portal, and any third-party’s User Content
        at any time with or without notice for any or no reason. Authorized
        Users As a user of the website, you affirm that you are 18 years of age
        or older. GFN Capital will not consider nor retain any applications,
        comments or information submitted by persons under the age of 18. You
        assume all responsibility for your use of, or access to, the website,
        including your access to any website content or user content, and hereby
        waive all claims or causes of action against GFN Capital, its
        affiliates, licensors and their respective officers, directors,
        employees, agents and representatives in connection therewith.
        Third-Party Links Links on this website are provided solely as a
        convenience to you. By clicking on these links, you understand that you
        are leaving the GFN Capital site, and are no longer governed by these
        Terms of Use and Privacy Policy. GFN Capital is not responsible for the
        availability or content of any third-party website. Keep in mind that
        third-party websites may have different terms of use and privacy
        policies. Feedback GFN Capital may offer the opportunity to provide
        feedback as a part of its services. By providing feedback to GFN
        Capital, you give a non-exclusive, irrevocable, perpetual and
        sub-licensable right for us to share the information in any format and
        for any purpose, including but not limited to, advertising use. No
        compensation will be paid to you for your submission, and GFN Capital is
        under no obligation to use or post any information provided. You warrant
        that you own or control all of the rights to all content, photographs,
        videos or images, and that such content, photographs, videos and images
        do not infringe upon the intellectual property rights of any third
        parties. You agree to indemnify GFN Capital, our affiliates, agents and
        partners for any and all claims resulting from the content you submit.
        You may not post content that is unlawful, obscene, threatening,
        inflammatory, libelous, defamatory, or that includes any misleading
        information. GFN Capital may remove any submission at any time in its
        sole discretion. Ownership GFN Capital retains all right, title and
        interest in this website and its content, designs and layouts,
        functions, graphics, photographs, music, sound, features and services
        offered on this website, including any and all copyright, trademark and
        other intellectual property rights. GFN Capital reserves all rights not
        expressly granted. All third-party trademarks, service marks, trade
        names, logos, or other designations of source are the property of their
        respective owners. Nothing on any Site shall be construed as granting
        any license or right not expressly set forth herein. Authorization to
        Contact You by Telephone You authorize GFN Capital, our affiliates,
        agents, partners and independent contractors to contact you at any
        telephone number you provide to us or from which you place a call to us,
        or any telephone number where we believe we may reach you, using any
        means of communication, including but not limited to, calls or text
        messages to mobile, cellular, wireless or similar devices and calls or
        text messages using an automated telephone dialing system and/or
        artificial voices or prerecorded messages, even if you incur charges for
        receiving such communications. Electronic Communications By using parts
        of this website, or sending e-mails to GFN Capital, you are
        communicating with us electronically. You agree to receive
        communications from us electronically, and that all agreements, notices,
        disclosures and other communications that we, our affiliates, partners
        or independent contractors provide to you electronically satisfy any
        legal requirement that such communication be in writing and are
        effective immediately. If you are accessing our website and the
        disclosures via a mobile device (e.g., smart phone, tablet, etc.), you
        must make sure that you have software on your mobile device that allows
        you to print and save any and all disclosures provided to you during the
        application process. If you do not have these capabilities on your
        mobile device, please access this website or portal through a device
        that provides these capabilities. You may withdraw your consent to
        receive disclosures electronically by contacting us at the address
        below. However, once you have withdrawn your consent you will not be
        able to post any funding requests on our website. If you have a pending
        request on our website, we will terminate it and remove it from our
        system. If you have already received funding, all previously agreed to
        terms and conditions will remain in effect, and we will send disclosures
        to your verified business address provided during registration. You can
        contact us via email at info@gfncapital.com or by calling our Customer
        Success Team at 404-920-4946. You may also reach us in writing to us at
        the following address: GFN Capital, 20200 W Dixie HWY Miami, FL 33180,
        Attention: Customer Service. Disclaimer THE SITE, THE SITE CONTENT, AND
        THE USER CONTENT ARE MADE AVAILABLE “AS IS” AND “AS AVAILABLE” WITHOUT
        WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED. THIS INCLUDES, WITHOUT
        LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
        PARTICULAR PURPOSE, TITLE, ACCURACY, NON-INFRINGEMENT OR ENJOYMENT. WE
        MAKE NO GUARANTEE THAT THE SITE CONTENT OR USER CONTENT ON THE SITE IS
        UP-TO-DATE, ACCURATE, OR COMPLETE. YOU SHOULD NOT RELY ON IT FOR ANY
        DECISION OR TO TAKE ANY ACTION. WE HEREBY DISCLAIM ANY WARRANTY THAT THE
        SITE CONTENT OR USER CONTENT ON THE SITE WILL BE FREE OF INTERRUPTION,
        FREE OF ERRORS, OR THAT ANY OF THE SITES IS FREE OF VIRUSES, WORMS,
        TROJAN HORSES, OR OTHER CODE THAT MANIFESTS CONTAMINATING OR DESTRUCTIVE
        PROPERTIES. Limitation of Liability UNDER NO CIRCUMSTANCES SHALL GFN
        Capital OR ANY OF ITS AFFILIATES BE LIABLE TO YOU OR ANY OTHER PERSON
        FOR ANY DIRECT, SPECIAL, EXEMPLARY, INDIRECT, INCIDENTAL, CONSEQUENTIAL,
        OR PUNITIVE DAMAGES OR COSTS, OR ATTORNEY’S FEES ARISING OUT OF OR
        RELATING TO THESE TERMS, ACCESS TO, USE OF, OR THE OPERATION OF ANY
        SITE, ANY OF THE SITE CONTENT, OR USER CONTENT. YOUR SOLE AND EXCLUSIVE
        REMEDY AND GFN Capital's SOLE AND EXCLUSIVE LIABILITY TO YOU FOR ANY
        REASON SHALL BE FOR YOU TO DISCONTINUE YOUR ACCESS TO OR USE OF THE
        SITE. THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST
        EXTENT PERMITTED BY LAW IN THE APPLICABLE JURISDICTION. In the event
        State law does not allow the exclusion or limitation of liability for
        consequential or incidental damages, GFN Capital's liability shall be
        limited and warranties are excluded to the fullest extent permitted by
        law, but shall in no event exceed $100.00. You agree that any cause of
        action arising out of or related to GFN Capital, any website, or any
        website content or user content must be commenced within one (1) year
        after the cause of action accrues. Otherwise, such cause of action is
        permanently barred. Indemnification You agree to indemnify, defend, and
        hold harmless GFN Capital, its affiliates, licensors, and partners,
        including without limitation, GFN Capital's service providers and
        banks—and their respective officers, directors, employees, agents, and
        representatives—from and against all losses, expenses, damages and
        costs. This includes reasonable attorneys’ fees, for any claims, causes
        of actions, procedures or allegations arising out of or relating to any
        violation of these Terms of Use, your use of the website, website
        content, or user content (including but not limited to infringement of
        third parties’ worldwide intellectual property rights or negligent or 
        wrongful conduct) by you or any other person accessing any website on
        your behalf. GFN Capital reserves the right, at its own expense, to
        assume the exclusive defense and control of any matter otherwise subject
        to defense by you. Digital Millennium Copyright Act GFN Capital takes
        the issue of copyright infringement very seriously, and has adopted the
        following policy in accordance with the{" "}
        <a
          href="http://lcweb.loc.gov/copyright/legislation/dmca.pdf" 
          target="_blank"
          className="text-primary"
          rel="noreferrer"
        >
          Digital Millennium Copyright Act (DMCA){" "}
        </a>
        . It is GFN Capital's policy to (1) block access to or remove content
        posted by users that it believes in good faith to be copyrighted
        material that has been illegally copied and distributed by any of our
        advertisers, affiliates, content providers, members or users; and (2)
        remove and discontinue providing the service to repeat offenders. If you
        believe that any content on this website violates or infringes upon your
        intellectual property rights pursuant to Title 17, United States Code,
        Section 512(c)(2), please notify us immediately at info@gfncapital.com
        or 404-920-4946. (“Designated Agent”) with the following information:
        Identification of the copyrighted work claimed to have been infringed,
        or—if multiple copyrighted works at a single online site are covered by
        a single notification—a representative list of such works at that site;
        Identification of the material that is claimed to be infringing or to be
        the subject of infringing activity and that is to be removed or access
        to which is to be disabled and information reasonably sufficient to
        permit us to locate the material; Information reasonably sufficient to
        permit us to contact you, such as an address, telephone number, and, if
        available, an electronic mail address; A statement that you have a good
        faith belief that use of the material in the manner complained of is not
        authorized by the copyright owner, its agent, or the law; A statement
        that the information in the notification is accurate, and under penalty
        of perjury, that you are authorized to act on behalf of the owner of an
        exclusive right that is allegedly infringed; and A physical or
        electronic signature of a person authorized to act on behalf of the
        owner of a copyright that is allegedly infringed. You acknowledge that
        if you fail to comply with substantially all of the above requirements
        of this Section, your DMCA notice may not be valid and we may not be
        able to remove infringing content. Security You are responsible for
        maintaining the confidentiality of your identification and password
        information, and for restricting access to your computer or device. You
        agree to accept responsibility for all activities that occur under your
        identification and password. GFN Capital reserves the right to terminate
        your access to the website or portal, or cancel your user name and
        password at any time and for any reason including, without limitation,
        your violation of these Terms of Use. Governing Law and Jurisdiction
        These Terms of Use, and the interpretation, performance, and enforcement
        of your and GFN Capital's rights and duties, shall be construed in
        accordance with the laws of the State of Arizona, except for any
        conflict or choice-of-law principle thereof that would lead to the
        application of another jurisdiction’s laws to the rights and duties of
        the parties. By using any website, you agree to submit any and all
        disputes arising out of or relating to these Terms of Use to the
        exclusive jurisdiction of the state or federal courts located in New
        York County, New York, or, at GFN Capital's sole election, to binding
        arbitration before a single arbitrator pursuant to the American
        Arbitration Association’s Commercial Dispute Resolution Procedures, with
        such arbitration to take place in New York County, New York.
        Severability If any provision of these Terms of Use is deemed unlawful,
        void, or unenforceable, that provision is deemed severable from these
        Terms of Use and does not affect the validity and enforceability of any
        remaining provisions. Force Majeure GFN Capital shall not be liable for
        any failure or delay in performance due in whole or in part to any cause
        beyond the reasonable control of such party or its contractors, agents
        or suppliers, including but not limited to utility or transmission
        failures, power failure, strikes or other labor disturbances, acts of
        God, acts of war or terror, floods, sabotage, fire, natural or other
        disasters. Contact Us If you have any questions or concerns about these
        Terms of Use, please contact us at info@gfncapital.com or 404-920-4946.
      </p>
    </div>
  );
};

export default TermsAndConditions;
